export enum TextColor {
  Inherit = 'inherit',
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Quaternary = 'quaternary',
  Danger = 'danger',
}

export enum TextSize {
  Xxs = 'xxs',
  Xs = 'xs',
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
  Xl = 'xl',
}

export enum TextWeight {
  Bold = 'bold',
  Semibold = 'semibold',
  Medium = 'medium',
  Regular = 'regular',
}

export enum TextEllipsis {
  Single = 'single',
  Multiple = 'multiple',
  None = 'none',
}

/**
 * Font family options for the Text component.
 */
export enum FontFamily {
  /** Inter Variable - default sans-serif font */
  Sans = 'sans',
  /** Crimson Pro Variable - serif font for headings */
  Serif = 'serif',
  /** JetBrains Mono - monospace font for data and code */
  Mono = 'mono',
}

/**
 * Semantic text variants that combine font-family, size, and weight.
 * These map to the design system typography specs.
 */
export enum TextVariant {
  /** Crimson Pro, Regular, 32px - Section headers on Home/Explore pages */
  HeaderMd = 'header-md',
  /** Inter, Medium, 18px - PDP Title */
  LgMedium = 'lg-medium',
  /** Inter, Medium, 16px - Section header on Explore page dropdown */
  MdMedium = 'md-medium',
  /** Inter, Regular, 16px - Input select */
  MdRegular = 'md-regular',
  /** Inter, Semibold, 14px - Button strings, Tab strings */
  SmSemibold = 'sm-semibold',
  /** Inter, Medium, 14px - Descriptions in Optimization Card, Input labels */
  SmMedium = 'sm-medium',
  /** Inter, Regular, 14px - Descriptions in modals and Explore Page */
  SmRegular = 'sm-regular',
  /** Inter, Semibold, 12px - Header in Optimization Card, metadata header, breadcrumb */
  XsSemibold = 'xs-semibold',
  /** Inter, Medium, 12px - Dropdown item breadcrumb */
  XsMedium = 'xs-medium',
  /** Inter, Regular, 12px - Metadata/info on PDP or Image Details Page, Radio Group item */
  XsRegular = 'xs-regular',
  /** Inter, Medium, 8px - Uppercase label with letter spacing */
  Label = 'label',
  /** JetBrains Mono, Regular, 10px - Captions like "ASSET MIX" */
  MonoXs = 'mono-xs',
  /** JetBrains Mono, Medium, 12px - Denominators like "of 7 required types" */
  MonoSm = 'mono-sm',
  /** JetBrains Mono, Bold, 24px, lh 32px - Medium data numbers */
  MonoMd = 'mono-md',
  /** JetBrains Mono, Bold, 36px, lh 32px - Larger data numbers */
  MonoLg = 'mono-lg',
  /** JetBrains Mono, Bold, 42px, lh none - Score metric cell numerators */
  MonoXl = 'mono-xl',
  /** JetBrains Mono, Bold, 48px, lh 64px - Score stickers */
  MonoXxl = 'mono-xxl',
}
